import React from 'react'
import ActionUiHandler from '@ui/template/actionUiHandler/ActionUiHandler'
import NotFound from '@ui/notFound/NotFound'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import {SxType} from '@baseTypes/sx/sxTypes'
import {useQueryState} from '@hooks/query/useQueryState'
import {useGetRecordingsUploadedListQuery} from '@containers/monitoringPlatform/geoZones/queryHooks/useRecordingsUploadedQuery'
import {RecordingsList} from '@containers/monitoringPlatform/geoZones/list/RecordingsList'

const sx: SxType = {
	height: '100%',
}

const RecordingsByAccount = () => {
	const {account} = useAppContext()

	const [inGeozoneOnly, setInGeozoneOnly] = useQueryState<boolean>('gzInZoneOnly', false, {
		parse: (value) => value === 'true'
	})

	const {
		data,
		isLoading,
		isFetching,
	} = useGetRecordingsUploadedListQuery(account.id, inGeozoneOnly)

	return (
		<ActionUiHandler
			isLoading={isFetching}
			isLoadingWithoutRender={isLoading}
			sx={sx}
		>
			{!data?.length && !isLoading && !isFetching && <NotFound/>}

			<RecordingsList
				recordings={data || []}
				accountId={account.id}
				inGeozoneOnly={inGeozoneOnly}
				setInGeozoneOnly={setInGeozoneOnly}
			/>
		</ActionUiHandler>
	)
}

export default RecordingsByAccount
